import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M7 9v6h4l5 5V4l-5 5H7z" />, 'VolumeMute');
